import { array, object, string } from 'yup';
import { WebhookEvents } from 'api';

const WorkVivoSchema = object().shape({
  workvivo_org_id: string().required('WorkVivo Org ID is Required'),
  api_token: string().required('API Token is Required'),
});

const GenericWebhookSchema = object().shape({
  callback_url: string().required('Callback URL is Required'),
  secret_token: string().required('Secret is Required'),
  webhook_events: array()
    .of(string().oneOf(Object.values(WebhookEvents)))
    .required('Webhook Events are required'),
  webhook_name: string().required('Webhook Name is required'),
});

export { WorkVivoSchema, GenericWebhookSchema };
